module.exports = __webpack_public_path__ + "img/bottom-right-blop.3d1de457.svg";